










































import Vue from "vue";
import AdminService from "@/services/adminService";

export default Vue.extend({
  name: "ProjectConfig",

  data() {
    return {
      JiraProjectKey: "",
      JiraLabelKey: "",
      show: false,
      updating: false
    };
  },
  async created() {
    const jwt = window.localStorage.getItem("jwt");
    if (jwt) {
      const adminService = new AdminService(jwt);
      const response = await adminService.getProjectConfig();
      if (response && response.status == 200) {
        if (response.data) {
          this.JiraProjectKey = response.data["JiraProjectKey"];
          this.JiraLabelKey = response.data["JiraLabelKey"];
          this.show = true;
        }
      }
    }
  },
  methods: {
    async submit(e) {
      this.updating = true;
      e.preventDefault();
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        const adminService = new AdminService(jwt);
        const formData = new FormData();
        formData.append("JiraProjectKey", this.JiraProjectKey.trim());
        formData.append("JiraLabelKey", this.JiraLabelKey.trim());
        const response = await adminService.updateProjectConfig(formData);
        if (response && response.status == 200) {
          if (response.data) {
            this.updating = false;
            alert("Update Successfully");
            await this.$router.push("/admin-panel");
          }
        }
      }
    },
    async cancel() {
      await this.$router.push("/admin-panel");
    }
  }
});
